import Md5 from 'md5';
import { Params } from '@/libs/types';
import {
    verifyTwice,
    login,
    logout,
    register,
    sendCode,
    sendRegEmail,
    sendRegMessage,
    sendResetPasswordEmail,
    sendResetPasswordPhone,
    verifyPasswordCode,
    updateResetPassword,
    updateResetGroup,
    shopQuickRegister,
} from '@/api/sys/user/passport';
import { clearLoginStatus, localSave } from '@/libs/util';
import config from '@/config/index';
import Vue from 'vue';
import Cookies from 'js-cookie';

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        // 两步验证登录
        handleVerifyTwice({ commit }: any, data: any) {
            return new Promise<void>((resolve, reject) => {
                verifyTwice({
                    verify_key: data.verify_key || '',
                    id: data.id,
                    code: data.code,
                })
                    .then((res: any) => {
                        if (!res) {
                            return;
                        }
                        const { cpl } = res.data.data;
                        localSave(config.tokenKey, cpl || '');
                        commit('user/setToken', cpl, { root: true });
                        commit('user/setUserId', '', { root: true });
                        resolve(res);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        // 登录
        handleLogin({ commit }: any, {
            userName, email, loginName, password, status, language, uniqueId, shop_id, shop_name, source, redirect_url, tem_token, auth_code, code,
        }: Params) {
            return new Promise<void>((resolve, reject) => {
                login({
                    userName,
                    email,
                    loginName,
                    password,
                    status,
                    language,
                    uniqueId,
                    shop_id,
                    shop_name,
                    // online_status ,
                    source,
                    redirect_url,
                    tem_token: tem_token || '',
                    auth_code: auth_code || '',
                    code: code || '',
                })
                    .then((res: any) => {
                        if (!res) {
                            return;
                        }
                        const { cpl, verify_key } = res.data.data;
                        if (!cpl && verify_key) {
                            // 没有cpl代表该账号开启了两步验证，需输入验证码
                            resolve(res);
                            return;
                        }
                        localSave(config.tokenKey, cpl || '');
                        commit('user/setToken', cpl, { root: true });
                        commit('user/setUserId', '', { root: true });
                        resolve(res);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        // 退出登录
        handleLogOut({ state, commit }: any) {
            return new Promise((resolve, reject) => {
                logout()
                    .then(() => {
                        clearLoginStatus();
                        commit('user/setToken', '', { root: true });
                        commit('user/setUserId', '', { root: true });
                        commit('user/setProjectId', '', { root: true });
                        commit('user/setProjectCode', '', { root: true });
                        commit('user/setProject', '', { root: true });

                        if (window.ssmEvent) {
                            window.ssmEvent.track('clearUser');
                            window.ssmEvent.track('chatClose');
                        }
                        resolve(() => {
                            commit('user/setAccess', [], { root: true });
                        });
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        // 注册
        handleRegister({ commit }: any, {
            name, user_name, email, phone, password, code, inviteCode, language, source, timeZone, uniqueId, projectName, shop_id, shop_name, shop_source, type, redirect_url, verify_ticket, verify_randstr, verify_code,
        }: Params) {
            console.log('handleRegister shop', shop_id, shop_source);
            // email = email.trim();
            return new Promise((resolve, reject) => {
                register({
                    name,
                    user_name,
                    email,
                    phone,
                    password: Md5(password),
                    code,
                    inviteCode,
                    language,
                    source,
                    timeZone,
                    uniqueId,
                    shop_id,
                    shop_name,
                    shop_source,
                    projectName,
                    type,
                    redirect_url,
                    verify_ticket,
                    verify_randstr,
                    verify_code, // 验证码
                })
                    .then((res: any) => {
                        if (window.ss_report) {
                            const userInfo: any = {};
                            if (email) {
                                userInfo.email = email;
                            }
                            if (phone) {
                                const phoneValue = String(phone);
                                userInfo.phone_number = phoneValue[0] === '+' ? phoneValue : `+86${phoneValue}`;
                            }
                            window.ss_report('register', {
                                ...res.data,
                                user_info: userInfo,
                            });
                        }
                        const ss_ref = Cookies.get('ref') || '';
                        Vue.prototype.$log('SS_REGISTER', 'REGISTER_SUCCESS', { data: { res, ref: ss_ref, type: 'register' } });
                        resolve(res);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        handleShopQuickRegister({ commit }: any, {
            user_name,
            password,
            source,
            shop_id,
            verify_ticket,
            verify_randstr,
            email,
            unique_id,
            time_zone,
            language,
        } : any) {
            return new Promise((resolve, reject) => {
                const params: any = {
                    shop_id,
                    source,
                    language,
                    time_zone,
                    unique_id,
                };
                if (verify_ticket && verify_randstr) {
                    params.verify_ticket = verify_ticket;
                    params.verify_randstr = verify_randstr;
                }

                if (user_name && password) {
                    params.user_name = user_name;
                    params.password = Md5(password);
                }

                if (email) {
                    params.email = email;
                }

                if (language) {
                    params.language = language;
                }

                if (time_zone) {
                    params.time_zone = time_zone;
                }

                if (unique_id) {
                    params.unique_id = unique_id;
                }

                shopQuickRegister(params)
                    .then((res: any) => {
                        if (!res) {
                            return;
                        }
                        if (window.ss_report) {
                            const userInfo: any = {};
                            if (email) {
                                userInfo.email = email;
                            }
                            window.ss_report('register', {
                                ...res.data.data,
                                user_info: userInfo,
                            });
                        }
                        const ss_ref = Cookies.get('ref') || '';
                        Vue.prototype.$log('SS_REGISTER', 'REGISTER_SUCCESS', { data: { res, ref: ss_ref, type: 'shopQuickRegister' } });
                        const { cpl } = res.data.data;
                        localSave(config.tokenKey, cpl || '');
                        commit('user/setToken', cpl, { root: true });
                        commit('user/setUserId', '', { root: true });
                        resolve(res);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        // 发送邮件（重置密码）
        resendCode({ commit }: any, {
            email,
            language,
        }: Params) {
            return new Promise((resolve, reject) => {
                sendCode({
                    email,
                    language,
                })
                    .then((res: any) => {
                        resolve(res);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        // 发送邮件
        sendRegEmail({ commit }: any, {
            email,
            key,
            language,
            shop_id,
            shop_source,
            type,
        }: Params) {
            return new Promise<void>((resolve, reject) => {
                sendRegEmail({
                    email, key, language, shop_id, type, shop_source,
                })
                    .then((res: any) => {
                        resolve();
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        // 发送信息
        sendRegMessage({ commit }: any, phone: number) {
            return new Promise<void>((resolve, reject) => {
                sendRegMessage(phone)
                    .then((res: any) => {
                        resolve();
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        sendResetPasswordEmail({ commit }: any, { email, url }: Params) {
            return new Promise<void>((resolve, reject) => {
                sendResetPasswordEmail({
                    email,
                    url,
                })
                    .then((res: any) => {
                        resolve();
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        sendResetPasswordPhone({ commit }: any, phone: number) {
            return new Promise<void>((resolve, reject) => {
                sendResetPasswordPhone(phone)
                    .then((res: any) => {
                        resolve();
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        verifyPasswordCode({ commit }: any, { phone, code }: Params) {
            return new Promise((resolve, reject) => {
                verifyPasswordCode({
                    phone,
                    code,
                })
                    .then((res: any) => {
                        resolve(res.data);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        updateResetPassword({ commit }: any, params: Params) {
            return new Promise((resolve, reject) => {
                const data: any = {
                    code: params.code,
                    password: Md5(params.password),
                };
                if (params.email) {
                    data.email = params.email;
                }
                if (params.phone) {
                    data.phone = params.phone;
                }
                updateResetPassword(data)
                    .then((res: any) => {
                        resolve(res.data);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        updateResetGroup({ commit }: any, { token, type }: Params) {
            return updateResetGroup({ token, type });
        },
        passiveLogout({ commit }: any) {
            return new Promise((resolve) => {
                clearLoginStatus();
                commit('user/setToken', '', { root: true });
                commit('user/setUserId', '', { root: true });
                commit('user/setProjectId', '', { root: true });
                commit('user/setProjectCode', '', { root: true });
                commit('user/setProject', '', { root: true });

                if (window.ssmEvent) {
                    window.ssmEvent.track('clearUser');
                    window.ssmEvent.track('chatClose');
                }
                resolve(() => {
                    commit('user/setAccess', [], { root: true });
                });
            });
        },
    },
};
